<template lang="html">
  <li>{{ date }}：<a v-bind:href="post.link">{{ post.title.rendered }}</a></li>
</template>

<script>

export default {
  name: 'NewsList',
  props: {
    post: {
      type: Object,
      default() {
        return {
          date: '',
          link: '',
          title: { rendered: '' },
        };
      },
    },
  },

  mounted() {
    if (!this.post.id) {
      this.getPost();
      this.isSingle = true;
    }
  },

  computed: {
    date() {
      const date = new Date(this.post.date);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${y}.${m}.${d}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  li {
    overflow: hidden;
    color: #00b0ec;
    font-family: '游ゴシック' , 'Yu Gothic' , '游ゴシック体' , 'YuGothic' , serif;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  a {
    font-family: '游ゴシック' , 'Yu Gothic' , '游ゴシック体' , 'YuGothic' , serif;
  }
</style>



// WEBPACK FOOTER //
// NewsList.vue?37e0635a